import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import { request } from "@/js/http/http_request";
import { getClientAppData } from "@/js/http/auth";
import axios from "axios";
import { getErrorData } from "@/js/forms.js";
import SupplierDialog from "@/components/supplier-prices/SupplierDialog.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
export default {
  //TODO : Rename file + name here -> SupplierListModal
  name: "SupplierListModal",
  components: {
    SupplierDialog: SupplierDialog,
    Confirm: Confirm
  },
  data: function data() {
    return {
      shown: false,
      options: {
        zIndex: 1000
      },
      clientAppData: null,
      search: "",
      headers: [{
        text: "Supplier",
        value: "name"
      }, {
        text: "Email",
        value: "email"
      }, {
        text: "Status",
        value: "status",
        align: "center"
      }, {
        text: "Supplier prices actions",
        value: "prices-actions",
        align: "center"
      }, {
        text: "Supplier actions",
        value: "actions"
      }],
      supplierModalShown: false,
      gettingSuppliers: {
        results: [],
        cancellationToken: null,
        isPending: false
      },
      editSupplier: null,
      gettingCountries: {
        countries: [],
        states: [],
        isPending: false
      },
      deletingSupplier: {
        isPending: false,
        cancellationToken: null
      },
      undeletingSupplier: {
        isPending: false,
        cancellationToken: null
      },
      deletingSupplierPrices: {
        isPending: false,
        cancellationToken: null
      }
    };
  },
  computed: {
    isAnyActionPending: function isAnyActionPending() {
      return this.gettingSuppliers.isPending || this.deletingSupplier.isPending || this.undeletingSupplier.isPending || this.deletingSupplierPrices.isPending || this.gettingCountries.isPending;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.clientAppData = getClientAppData(_this2);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open() {
      this.fetchCountries();
      this.fetchSuppliers();
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
    },
    fetchSuppliers: function fetchSuppliers() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$gettingSupplie;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.gettingSuppliers.results = [];
              _this3.gettingSuppliers.isPending = true;
              (_this3$gettingSupplie = _this3.gettingSuppliers.cancellationToken) === null || _this3$gettingSupplie === void 0 || _this3$gettingSupplie.cancel();
              _this3.gettingSuppliers.cancellationToken = axios.CancelToken.source();
              _this = _this3;
              _context2.next = 7;
              return request("/v1/suppliers/only", "get", null, true, "api", null, _this3.gettingSuppliers.cancellationToken).catch(function (e) {
                _this.$toasted.show("Unable to load suppliers.", {
                  type: "error"
                });
                throw e;
              });
            case 7:
              response = _context2.sent;
              _this3.gettingSuppliers.cancellationToken = null;
              _this3.gettingSuppliers.isPending = false;
              _this3.gettingSuppliers.results = response.data.value;
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    saveSupplier: function saveSupplier(supplier, ackowledge) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, url, method;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isReloading = true;
              _this = _this4;
              url = supplier.id ? "/v1/suppliers/".concat(supplier.id) : "/v1/suppliers";
              method = supplier.id ? "put" : "post";
              _context3.next = 6;
              return request(url, method, supplier, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save the supplier.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                ackowledge();
                _this.isReloading = true;
                throw e;
              });
            case 6:
              _this4.$toasted.show("Supplier saved successfully.", {
                type: "success"
              });
              _this4.fetchSuppliers();
              ackowledge();
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    confirmDeleteSupplierPrices: function confirmDeleteSupplierPrices(supplier) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.$refs.confirm.open("Delete supplier prices", "Are you sure you want to delete all prices for supplier : ".concat(supplier.name, "?"));
            case 2:
              isConfirmed = _context4.sent;
              if (isConfirmed) {
                _this5.DeleteSupplierPrices(supplier);
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    DeleteSupplierPrices: function DeleteSupplierPrices(supplier) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this6$deletingSuppli;
        var _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.deletingSupplierPrices.isPending = true;
              (_this6$deletingSuppli = _this6.deletingSupplierPrices.cancellationToken) === null || _this6$deletingSuppli === void 0 || _this6$deletingSuppli.cancel();
              _this6.deletingSupplierPrices.cancellationToken = axios.CancelToken.source();
              _this = _this6;
              _context5.next = 6;
              return request("/v1/suppliers/".concat(supplier.id, "/prices"), "delete", null, true, "api", null, _this6.deletingSupplierPrices.cancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to delete supplier prices.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                _this.deletingSupplierPrices.isPending = false;
                throw e;
              });
            case 6:
              _this6.$toasted.show("Supplier prices deleted successfully.", {
                type: "success"
              });
              _this6.deletingSupplierPrices.cancellationToken = null;
              _this6.deletingSupplierPrices.isPending = false;
              _this6.fetchSuppliers();
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    confirmDeleteSupplier: function confirmDeleteSupplier(supplier) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this7.$refs.confirm.open("Delete supplier", "Are you sure you want to delete supplier : ".concat(supplier.name, "? All related prices will be deleted as well."));
            case 2:
              isConfirmed = _context6.sent;
              if (isConfirmed) {
                _this7.DeleteSupplier(supplier);
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    DeleteSupplier: function DeleteSupplier(supplier) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this8$deletingSuppli;
        var _this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this8.deletingSupplier.isPending = true;
              (_this8$deletingSuppli = _this8.deletingSupplier.cancellationToken) === null || _this8$deletingSuppli === void 0 || _this8$deletingSuppli.cancel();
              _this8.deletingSupplier.cancellationToken = axios.CancelToken.source();
              _this = _this8;
              _context7.next = 6;
              return request("/v1/suppliers/".concat(supplier.id), "delete", null, true, "api", null, _this8.deletingSupplier.cancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to delete supplier.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                _this.deletingSupplier.isPending = false;
                throw e;
              });
            case 6:
              _this8.$toasted.show("Supplier deleted successfully.", {
                type: "success"
              });
              _this8.deletingSupplier.cancellationToken = null;
              _this8.deletingSupplier.isPending = false;
              _this8.fetchSuppliers();
            case 10:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    fetchCountries: function fetchCountries() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this9.gettingCountries.isPending = true;
              _this = _this9;
              _context8.next = 4;
              return request("/v1/countries", "post", _this9.clientAppData, false, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load intended countries.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 4:
              response = _context8.sent;
              if (response) {
                _this9.gettingCountries.countries = _toConsumableArray(response.data.countries);
                _this9.gettingCountries.states = _toConsumableArray(response.data.states);
                _this9.gettingCountries.isPending = false;
              }
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    closeNewSupplierDialog: function closeNewSupplierDialog() {
      this.editSupplier = null;
      this.supplierModalShown = false;
    },
    openNewSupplierDialog: function openNewSupplierDialog() {
      this.editSupplier = null;
      this.supplierModalShown = true;
    }
  }
};